import { trpc } from '@/trpc/client';

export function useCurrentUser() {
  return trpc.user.me.useQuery(undefined, {
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false,
  });
}
